export const LoginRequestInit = {
    deviceId: "",
    latitude: "",
    longitude: "",
    userEmail: "",
    userPassword: ""
};
